import {defaultPartner} from './../config/app-config';
import {parseDateIntoHermesString} from './date-utils';

const makeDetailsPageUrl = ({
  hotelData = {},
  partner = defaultPartner,
  checkin,
  checkout,
  roomString,
  staticData = {},
  destination = {},
  cityMetaInfo = {},
  filter = {},
  metaPartner = '',
  offerCode,
  appliedFilters = [],
}) => {
  let coc = '';

  if (cityMetaInfo) {
    coc = cityMetaInfo.coc;
  }

  const {ct = {}, xtr = {}, n: destinationCityName, t = ''} = destination;

  let cityName = destinationCityName;
  if (t === 'hotel' && staticData && Object.keys(staticData).length > 0) {
    cityName = staticData?.c;
  }

  const {cc = ''} = xtr;

  if (xtr && xtr.flt) {
    const {n: voyCityName = ''} = ct;
    cityName = voyCityName;
  }

  const {date: checkinDate} = checkin;
  const {date: checkoutDate} = checkout;
  let hmd = '';
  const {hn, hc, ibp = ''} = hotelData;
  if (hotelData.hmd) hmd = hotelData.hmd;
  const hName = hn.replace(/\//g, ' ').toLowerCase();
  let urlHname = hName.replace(/[^\w\s]/gi, '').split(' ');
  urlHname = urlHname.filter(el => {
    if (el !== '' && el !== 'hotel') {
      return true;
    }
  });

  urlHname = urlHname.join('-');
  const {hctx = '', sctx = []} = filter;
  const hotelContext = hctx ? `&hctx=${hctx}` : '';
  const subContext = sctx && sctx.length ? `&sctx=${sctx}` : '';
  const isMeta = metaPartner ? `&metaTraffic=${metaPartner}` : '';
  const isHmd = hmd ? `&hmd=${hmd}` : '';
  const isOfferCode = offerCode ? `&offerCode=${offerCode}` : '';
  const hotelQueryString = JSON.stringify({
    ci: parseDateIntoHermesString(checkinDate),
    co: parseDateIntoHermesString(checkoutDate),
    r: roomString,
    ibp,
  });

  const appliedFiltersQueryParam =
    appliedFilters.length > 0 ? `&appliedFilters=${JSON.stringify(appliedFilters)}` : '';
  // TO:DO: fdwp param
  const countryCode = coc || cc; // priority to hermes data, fallback to autosuggest data
  const sec = countryCode.toLowerCase() === 'in' ? '&sec=dom' : '&sec=int';
  return `/${partner}/${urlHname}-hotel-in-${encodeURIComponent(cityName)}-${hc}/?hquery=${hotelQueryString}${hotelContext}${subContext}${isMeta}${isOfferCode}${isHmd}${
    countryCode ? sec : ''
  }${appliedFiltersQueryParam}`;
};

export default makeDetailsPageUrl;
